<div
  class="tw-px-2 tw-pt-2"
  [class]="
    sideNavService.open()
      ? 'tw-sticky tw-top-0 tw-z-50 tw-pb-4'
      : 'tw-pb-[calc(theme(spacing.8)_+_2px)]'
  "
>
  <!-- absolutely position the link svg to avoid shifting layout when sidenav is closed -->
  <a
    [routerLink]="route()"
    class="tw-relative tw-p-3 tw-block tw-rounded-md tw-bg-transparent tw-outline-none tw-font-bold tw-h-full hover:tw-no-underline focus-visible:tw-ring focus-visible:tw-ring-inset focus-visible:tw-ring-text-alt2 hover:tw-bg-hover-contrast"
    [ngClass]="{
      '!tw-h-[55px] [&_svg]:!tw-w-[26px]': !sideNavService.open,
    }"
    [attr.aria-label]="label()"
    [title]="label()"
    routerLinkActive
    ariaCurrentWhenActive="page"
  >
    <div class="tw-flex tw-justify-center tw-items-center" aria-hidden="true">
      <i class="tw-w-6 bwi bwi-lg {{ closedIcon() }}"></i>
      <span class="tw-truncate" *ngIf="sideNavService.open">{{ label() }}</span>
    </div>
  </a>
</div>
